import { TextField } from '@mui/material';
import KeyIcon from '@mui/icons-material/Key';
import InputAdornment from '@mui/material/InputAdornment';

const OtpTextField = ({ otpSetter }) => {
  const captureKeyStroke = e => {
    if (e.key === 'Enter') {
      otpSetter(e.target.value);
    }
  };

  return (
    <TextField
      label='Enter OTP'
      name='otp'
      onKeyDown={captureKeyStroke}
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <KeyIcon />
          </InputAdornment>
        ),
      }}
      inputRef={input => input && input.focus()}
      inputProps={{ 'data-cy': 'otp-textfield' }}
    />
  );
};

export default OtpTextField;
